import { render } from "./AddProductToCartSuccessModal.vue?vue&type=template&id=34ed85f5"
import script from "./AddProductToCartSuccessModal.vue?vue&type=script&lang=js"
export * from "./AddProductToCartSuccessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__